import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, Drawer, Input, Field } from '@itds/elements/index.js';

import { Api } from '@brokerage/utils/Api';

const Edit = ({ field, onClose, onSave, show }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    const new_field = field || {};

    setData({
      help_content: new_field.help_content,
      is_visible: new_field.is_visible,
      is_visible_on_config: new_field.is_visible_on_config,
      is_required: new_field.is_required
    });
  }, [field]);

  const handleInputChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleCheckboxChange = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const handleSave = () => {
    Api.updateWebsiteQuoterField(field.id, data).then(() => {
      onSave();
    });
  };

  return (
    <Drawer
      alignRight={true}
      footer={<Button onClick={handleSave}>Save Change</Button>}
      onClose={onClose}
      show={show}
      title='Editing Lead Form Field'
    >
      <Field label='Label'>
        <Input readOnly={true} value={field ? field.label : ''} />
      </Field>

      <Field label='Help Content'>
        <Input
          onChange={handleInputChange.bind(null, 'help_content')}
          type='textarea'
          value={data.help_content}
        />
      </Field>

      <Field>
        <Checkbox
          checked={data.is_visible}
          label='Visible'
          onChange={handleCheckboxChange.bind(null, 'is_visible')}
        />
      </Field>

      <Field>
        <Checkbox
          checked={data.is_visible_on_config}
          label='Visible w/ Config'
          onChange={handleCheckboxChange.bind(null, 'is_visible_on_config')}
        />
      </Field>

      <Field>
        <Checkbox
          checked={data.is_required}
          label='Required'
          onChange={handleCheckboxChange.bind(null, 'is_required')}
        />
      </Field>
    </Drawer>
  );
};

Edit.propTypes = {
  field: PropTypes.object,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  show: PropTypes.bool
};

export default Edit;
